import { ReactComponent as TextWhiteLogo } from './assets/TextWhiteLogo.svg';

export const AppLogoTextWhite = TextWhiteLogo;
